import React from 'react' //{useState}
import TicketsCrud from '../../modules/custom/tickets/crudTickets'

const Tickets: React.FC = () => {


  return (
    <TicketsCrud></TicketsCrud>
  )
}

export {Tickets}
